/* eslint-disable no-undef */
/**
* created by yujintong
* var picker = new nPicker({
    value: String|Array //默认选中的值，支持模糊匹配;如：['广东','深圳','南山区']或广东省,深圳市,南山区
    confirm: Function(result[Array]) //选择后的回调，接收选择器结果，格式为数组
    cancel: Function //关闭选择器回调,
    level: Number //层级数，0开始计数，默认无限级，可以用来控制选择仅支持到市或者省等用处,
    others: Object|null //指定某一层级是否增加空选项，如{level2: "暂无选择",level1: "暂不选择"}分别往第三级第二级的数据增加一个选项，默认为{level2: "暂不选择"}
  })
  API:
    picker.show(value);//显示选择器，接收一个默认值
    picker.hide();//隐藏选择器
**/
import area from "./areas";
import Axios from "axios";
import util from "./util";

var PICKERCOUNT = 0;
var doResultSwitch = false;//由于有异步加载数据和传入默认值的可能，需要一个开关切换状态
var body = document.getElementsByTagName("body")[0];
var Util = {
  loop: function(start, end, handle) {
    for (var i = start; i < end; i++) {
      Util.isFunc(handle) && handle(i);
    }
  },
  isFunc: function(name) {
    return typeof name === 'function';
  },
  isArray: function(o) {
    return Object.prototype.toString.call(o) === '[object Array]';
  },
  createEle: function(parent, tag, className, html) {
    var ele = document.createElement(tag);
    className && ele.classList.add(className);
    html && (ele.innerHTML = html);
    parent && parent.appendChild(ele);
    return ele;
  },
  getEle: function(ctx, selector) {
    return ctx.querySelector(selector);
  },
  createData: function() {
    var data = area.province,
      city = area.city;
    var key = '';
    Util.loop(0, data.length, function(i) {
      key = data[i].code.slice(0, 2);
      data[i]['child'] = [];
      for (var j = 0, count = city.length; j < count; j++) {
        city[j].code.slice(0, 2) == key && data[i]['child'].push(city[j]);
      }
    })
    return data;
  },
  like: function(a, b) {
    return a.indexOf(b) > -1 || b.indexOf(a) > -1;
  }
}
var data = Util.createData();
loadCss();
function nPicker(config) {
  this.index = ++PICKERCOUNT; //当前选择器的索引
  this.value = config && config.value ? (Util.isArray(config.value) ? config.value : config.value.split(',')) : []; //选择器默认值
  this.confirm = config && config.confirm; //确定选择的回调
  this.cancel = config && config.cancel; //取消回调
  this.level = config.level;
  this.others = config.others ? config.others : config.others === null ? null : {level2: "暂不选择"}
  this.init();
}
nPicker.prototype = {
  constructor: nPicker,
  init: function() {
    var html = '<div class="n-picker-wrap"><div class="n-picker-load"></div><div class="n-picker-head">地区选择<div class="n-picker-close">+</div></div><div class="n-picker-nav"></div><div class="n-picker-body"></div></div>';
    var container = Util.createEle(body, 'div', 'n-picker', html);
    container.id = 'nPicker' + this.index;
    this.container = container;
    this.nav = Util.getEle(container, '.n-picker-nav');
    this.box = Util.getEle(container, '.n-picker-body');
    this.load = Util.getEle(container, '.n-picker-load');
    this.result = [];
    this.scrollCount = 0;
    this.createData(data);
    this.data = data;
    this.bindEvent(); //绑定事件
  },
  getOthers: function(index){//获取某一列是否需要增加暂不选择的选项
    if(this.others && this.others['level' + index]) {
      return {name: this.others['level' + index]}
    }
    return null;
  },
  createData: function(data) {
    var scroll = Util.createEle(this.box, 'ul');
    var nav = Util.createEle(this.nav, 'span', '', '请选择');
    scroll.scrollIndex = this.scrollCount++;
    nav.navIndex = scroll.scrollIndex;
    this.addList(scroll, data, this.getOthers(scroll.scrollIndex));
  },
  addList: function(parent, data, requireOthers) {
    var html = document.createDocumentFragment(),
      that = this;
    var index = -1,
      scrollIndex = parent.scrollIndex,
      li = null;
    parent.datas = data;
    Util.loop(0, data.length, function(i) {
      li = Util.createEle(html, 'li', '', data[i].name);
      li.liIndex = i;
      if (that.value.length && that.value[scrollIndex] && Util.like(data[i].name, that.value[scrollIndex])) {
        index = i; //初始化时有默认值，应该选中当前值，否则index就会为0，即选中第一个
      } else if(data.length == 1) {//只有一个则默认选中
        index = 0;
      }
    });
    /**
     * 增加是否有“暂无选择”之类的选项
     * 之所以在创建dom时创建而不在data里动态加入数据是因为，data是通用的，存在多个选择的引用
     * 而有些选择器可能不需要“暂不选择”这个选项
    */
    if(requireOthers) {
      li = Util.createEle(html, 'li', '', requireOthers.name);
      li.liIndex = data.length;
      if(that.value.length && that.value[scrollIndex] && Util.like(requireOthers.name, that.value[scrollIndex])) {
        index = data.length
      }
    }
    parent.innerHTML = '';
    parent.appendChild(html);
    this.updateActive(this.nav, scrollIndex);//更新nav高亮
    this.selectItem(data, index, scrollIndex); //选中并创建下一级选择器
  },
  updateActive: function(dom, index) {
    Util.loop(0, dom.childNodes.length, function(i) {
      dom.childNodes[i].classList.remove('active');
    });
    dom.childNodes[index].classList.add('active');
  },
  updateList: function(index, data) {
    var dom = this.box.childNodes[index];
    if (!dom) {
      this.createData(data);
      return;
    }
    this.addList(dom, data, this.getOthers(index));
  },
  setResult: function(data) {
    var res = {};
    for (var key in data)
      key != 'child' && (res[key] = data[key]);
    return res;
  },
  removeScroll: function(index, count) {
    for (var j = count - 1, len = index; j >= len; j--) { //删除多余的ul
      var node = this.box.childNodes[j],
        nav = this.nav.childNodes[j];
      if (node) {
        this.box.removeChild(node)
        this.scrollCount--;
        this.calcWidth();
      }
      nav && this.nav.removeChild(nav)
    }
  },
  calcWidth: function() {
    this.box.style.width = (this.scrollCount * 100) + '%';
    this.setOffset(this.scrollCount);
  },
  setOffset: function(index) {
    var offset = {
      y: 0
    };
    offset.x = -(100 / this.scrollCount * (index - 1)) + '%';
    this.setTransform(this.box, offset);
  },
  setTransform: function(dom, offset) {
    dom.style.webkitTransform = dom.style.transform = 'translate3d(' + [offset.x, offset.y].join(',') + ',0)';
  },
  selectItem: function(data, index, scrollIndex, click) { //params: 数据，选中的索引，当前scroll的索引
    var ul = this.box.childNodes[scrollIndex];
    var oldScrollCount = this.scrollCount;
    this.result.length = scrollIndex + 1; //重置结果集长度
    if (index == -1) {
      this.nav.childNodes[scrollIndex].innerText = '请选择';
      if (this.scrollCount > scrollIndex + 1) this.removeScroll(scrollIndex + 1, this.scrollCount)
      return;
    }
    this.updateActive(ul, index);
    this.result[scrollIndex] = this.setResult(data[index]); //当前层级选中结果
    this.nav.childNodes[scrollIndex].innerText = index >= data.length ? this.others['level' + scrollIndex] : data[index].name;
    if(typeof this.level !== 'undefined' && scrollIndex >= this.level || index >= data.length) {//限制了层级
      click && (doResultSwitch  = false);
      this.doResult();
      return;
    }
    if (data[index] && data[index]['child'] && Util.isArray(data[index]['child']) && data[index]['child'].length) { //存在子元素
      if (this.scrollCount < scrollIndex + 2) { //如果上一次的ul个数少于当前需要的个数，则创建新的ul
        this.createData(data[index]['child']);
      } else {
        this.updateList(scrollIndex + 1, data[index]['child']);
      }
      this.calcWidth();
    } else { //说明没有子元素，先向接口发起请求，再决定是否移除可能超过的选择器个数
      /**
       *以下代码为旧代码逻辑，为了防止发起不必要的请求，故对层级和直辖市做了限制，但现在要考虑以后增加选择器层级，所以放开限制，使选择器支持无限级
      **/
      // if (scrollIndex < 2 && data[index].child === undefined && "11|12|31|50".indexOf((data[index].code || data[index].number).substring(0, 2)) < 0) { //需要获取地区
      //   this.getChild(data[index], scrollIndex, oldScrollCount, click);
      // } else if ("11|12|31|50".indexOf((data[index].code || data[index].number).substring(0, 2)) >= 0 || scrollIndex >= 2) {
      //   this.value = [];
      //   click && this.doResult();
      // } else if (scrollIndex >= 1) {
      //   click && this.doResult();
      // }
      /**---------------**/
      if(data[index].child === undefined) {//说明了没有子元素而且还没发起过接口请求，发起过的会置位空数组，防止重复发起请求
        this.getChild(data[index], scrollIndex, oldScrollCount, click);
      } else {
        this.doResult();
      }
      //由于请求时异步，对可能超过选择器级数的暂时移除
      this.removeScroll(scrollIndex + 1, oldScrollCount);
    }
  },
  getChild: function(data, index, count, click) {
    var that = this;
    this.load.style.display = 'block';
    Axios.get('/tbnetwork/www/searchapi.do?method=getcounty&city=' + (data.code || data.number)).then(function(res) {
      let result = res.data;
      if (result.length) {
        data.child = result; //缓存数据
        that.updateList(index + 1, result);
        that.value = [];
        that.calcWidth();
      } else {
        data.child = [];
        that.removeScroll(index + 1, count);
        that.value = [];
        if(click) {
          doResultSwitch = false
          that.doResult();
        }
        that.calcWidth();
      }
      that.load.style.display = "none"
    }).catch(function(error) {
      console.log(error)
      util.tips("地区获取失败，请稍后再试")
    });
  },
  doResult: function() {
    if(doResultSwitch) {
      doResultSwitch = false;
      return;
    }
    Util.isFunc(this.confirm) && this.confirm(this.result);
    this.hide();
  },
  hide: function() {
    var that = this;
    this.value = [];
    that.setTransform(Util.getEle(that.container, '.n-picker-wrap'), {
      x: 0,
      y: '100%'
    })
    setTimeout(function() {
      that.container.style.display = 'none'
    }, 200)
  },
  show: function(value) {
    var that = this;
    doResultSwitch = true;
    if (value) {
      value = Util.isArray(value) ? value : value.split(',');
      if (value.length) {
        this.value = value;
        this.updateList(0, this.data);
      }
    } else {
      doResultSwitch = false;
    }
    that.container.style.display = 'block';
    setTimeout(function() {
      that.setTransform(Util.getEle(that.container, '.n-picker-wrap'), {
        x: 0,
        y: 0
      })
    }, 0)
  },
  bindEvent: function() {
    var that = this;

    function attach(dom, type, callback) {
      dom.addEventListener(type, function(event) {
        event = event || window.event;
        callback(event, event.target || event.srcElement);
      }, false)
    }
    attach(that.container, 'click', function(event,target) { //防止点透，用click
      target.matches('.n-picker') && that.hide();
    });
    attach(that.nav, "click", function(event, target) {
      if (target.nodeName.toLowerCase() == 'span') {
        var index = Math.max(0, +target.navIndex);
        that.setOffset(index + 1)
        that.updateActive(that.nav, index);
      }
    });
    attach(that.box, "click", function(event, target) {
      if (target.nodeName.toLowerCase() == 'li') {
        var index = Math.max(0, +target.liIndex),
          parent = target.parentNode;
        that.selectItem(parent.datas, index, parent.scrollIndex, true);
      }
    });
    attach(Util.getEle(that.container, '.n-picker-close'), 'touchstart', function() {
      that.hide();
      Util.isFunc(that.cancel) && that.cancel();
    });
  }
}
function loadCss() {
  var css = ".n-picker{-webkit-text-size-adjust:none;position:fixed;top:0;bottom:0;z-index:9999;width:100%;display:none}.n-picker .n-picker-wrap{position:relative;display:-webkit-box;-webkit-box-orient:vertical;-webkit-transition:all .2s;transition:all .2s;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);background:#fff;position:absolute;bottom:0;width:100%;height:50%;box-shadow:0 -5px 10px rgba(0,0,0,.2);overflow:hidden}.n-picker .n-picker-head{position:relative;text-align:center;padding:.8em}.n-picker .n-picker-close{color:#aaa;position:absolute;right:0;top:.4em;font-size:1em;line-height:2rem;padding:0 .5em;-webkit-transform:rotate(45deg);-webkit-transform-origin:50% 50%;transform:rotate(45deg);transform-origin:50% 50%}.n-picker .n-picker-nav{display:-webkit-box;overflow-x:auto;-webkit-overflow-scroll:touch;border-bottom:1px solid #f2f2f2}.n-picker .n-picker-nav>span{display:block;max-width:25%;text-align:center;white-space:nowrap;overflow:hidden;line-height:1.5em;text-overflow:ellipsis;border-bottom:2px solid transparent;padding:.5em 1em;box-sizing:border-box;font-size:.875rem}.n-picker .n-picker-nav>span.active{border-bottom:2px solid #ff7f02;color:#ff7f02}.n-picker .n-picker-body{width:200%;display:-webkit-box;-webkit-box-flex:1;-webkit-transform:translate3d(0,0,0);-webkit-transition:all .2s;transition:all .2s}.n-picker ul{-webkit-box-flex:1;-webkit-box-pack:start;width:0;overflow-y:scroll;-webkit-overflow-scrolling:touch;color:#888;font-size:.875rem;line-height:2.5em}.n-picker li{padding:0 1em}.n-picker li.active{color:#ff7f02}.n-picker li.active:after{display:inline-block;width:1em;height:.5em;margin-left:1em;vertical-align:middle;-webkit-transform:rotate(-45deg);-webkit-transform-origin:0 100%;border-left:1px solid #ff7f02;border-bottom:1px solid #ff7f02;content:''}.n-picker .n-picker-load{position:absolute;top:40%;left:50%;width:3rem;height:3rem;background:url(https://cdn.kuaidi100.com/images/m/scroll-loading.gif) center center no-repeat;margin-left:-1.5rem;display:none}";
  var doc = document;
  var style = doc.createElement("style"),cssText = doc.createTextNode(css),heads = doc.getElementsByTagName("head");
  style.setAttribute("type", "text/css");
  style.appendChild(cssText);
  if(heads.length){
    heads[0].appendChild(style);
  } else{
    doc.documentElement.appendChild(style);
  }
}
export default nPicker